export const environment = {
  production: false,
  baseCpuUrl: 'https://cpu.staging.breathment.com/',
  //baseSamuraiUrl: 'https://minnow-assuring-primarily.ngrok-free.app/',
  baseSamuraiUrl: 'wss://samurai.breathment.live/',
  firebaseStorageBucket: 'breathment-staging-bc2ad',
  APP_VERSION_ABC: '5fc756e851604e656fb0d5faddcb4749d440b1b1,staging'
};
